import { render } from "./DeleteUserModal.vue?vue&type=template&id=c85b9a9c&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"

import "./DeleteUserModal.vue?vue&type=style&index=0&id=c85b9a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85b9a9c"]])

export default __exports__